import { render, staticRenderFns } from "./DistribTaskSummary.vue?vue&type=template&id=585ca99f&"
import script from "./DistribTaskSummary.vue?vue&type=script&lang=js&"
export * from "./DistribTaskSummary.vue?vue&type=script&lang=js&"
import style0 from "./DistribTaskSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports